// extracted by mini-css-extract-plugin
module.exports = {"Tab":"index__Tab___2Q9Xo","activeTab":"index__activeTab___2nNDC"};